import { ElementRef, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { PDFDocument } from 'pdf-lib';
import printJS from 'print-js';

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  async mergePdfs(pdfBuffers: ArrayBuffer[]): Promise<Uint8Array> {
    const mergedPdf = await PDFDocument.create();

    for (const pdfBuffer of pdfBuffers) {
      const pdf = await PDFDocument.load(pdfBuffer);
      const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
      copiedPages.forEach((page) => mergedPdf.addPage(page));
    }

    const mergedPdfBytes = await mergedPdf.save();
    return mergedPdfBytes;
  }

  base64PdfToBlob(base64Pdf: string): Blob {
    var bufferArray = this.base64PdfToArrayBuffer(base64Pdf); // get the base64encoded response from backend side
    const pdfBlob = new Blob([bufferArray], { type: 'application/pdf' });
    return pdfBlob;
  }
  base64PdfToArrayBuffer (data: string): Uint8Array {
    var bString = window.atob(data);
    var bLength = bString.length;
    var bytes = new Uint8Array(bLength);
    for (var i = 0; i < bLength; i++) {
        var ascii = bString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
  };

  fetchPdf(url: string): Promise<Uint8Array> {
    return fetch(url, { method: 'GET' })
      .then((response) => {
        return response.blob();
      }).then(async (blob) => {
        return new Uint8Array(await blob.arrayBuffer());
      });
  }

  downloadBase64SheetFile(base64: string, fileName: string): void {
    const byteChars = atob(base64);

    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], {
      type: 
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    
  }

  downloadPdf(pdfBytes: Uint8Array, fileName: string): void {
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
  }

  printPdf(pdfBytes: Uint8Array): void {
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    printJS({ printable: url, type: 'pdf', base64: false });
    URL.revokeObjectURL(url);
  }
}
